import { type ReactNode } from "react";
import { Outlet } from "react-router";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { GlobalCommandPalette } from "@/components/command/GlobalCommandPalette";

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen min-h-dvh flex flex-col w-full overflow-x-clip bg-background text-foreground antialiased selection:bg-primary/20 selection:text-primary">
      <GlobalCommandPalette />
      <Header />
      <main id="main-content" className="flex-1 w-full min-w-0">
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
